module.exports = __webpack_public_path__ + "static/media/update.56a51878.webp";